var labels = {
  nueva_asignacion: {
    es: 'Nueva Asignación',
    en: 'New Assignment'
  },
  editar_asignacion: {
    es: 'Actualizar Asignación',
    en: 'Update Assignment'
  },
  nuevo_rol: {
    es: 'Nuevo Rol',
    en: 'New Rol'
  },
  user_email: {
    es: 'Correo de Usuario',
    en: 'User Email'
  },
  cancelar: {
    es: 'Cancelar',
    en: 'Cancel'
  },
  agregar: {
    es: 'Agregar',
    en: 'Add'
  },
  editar_fila: {
    es: 'Editar Fila',
    en: 'Edit Row'
  },
  cancelar_edicion: {
    es: 'Cancelar Edición',
    en: 'Cancel Edit'
  },
  eliminar_fila: {
    es: 'Eliminar Fila',
    en: 'Delete Row'
  },
  quitar: {
    es: 'Eliminar',
    en: 'Delete'
  },
  tabla_roles: {
    nivel: 2,
    rol: {
      es: 'Rol',
      en: 'Rol'
    },
    activo: {
      es: 'Activo',
      en: 'Active'
    },
    expiracion: {
      es: 'Expiración',
      en: 'Expiration'
    },
    domain: {
      es: 'Dominio',
      en: 'Domain'
    },
    subdomain: {
      es: 'Sub Dominio',
      en: 'Sub Domain'
    },
    acciones: {
      es: 'Acciones',
      en: 'Actions'
    }
  }
};
export default labels;